import * as React from "react";
import classnames from "classnames";
import { CheckboxList } from "@grandvisionhq/forms";
/* empty css              */
function ItemList({
  getItemIdentifier,
  getItemLabel,
  idPrefix,
  items,
  onChange,
  selectedItems,
  shouldIndent = false,
  getItemErrorMessage,
  shouldItemValidate
}) {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("checkout__consent", {
        "checkout__consent--indent": shouldIndent
      })
    },
    /* @__PURE__ */ React.createElement(
      CheckboxList,
      {
        getItemIdentifier,
        getItemErrorMessage,
        shouldItemValidate,
        idPrefix,
        items,
        onChange,
        renderItem: (item) => /* @__PURE__ */ React.createElement("span", null, getItemLabel(item)),
        selectedItems
      }
    )
  );
}
export {
  ItemList
};
//# sourceMappingURL=ItemList.js.map
